/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Checkout_Meta_DescriptionInputs */

const es_gift_checkout_meta_description = /** @type {(inputs: Gift_Checkout_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa la compra de tu tarjeta regalo Zarpar para alquileres y experiencias náuticas.`)
};

const gl_gift_checkout_meta_description = /** @type {(inputs: Gift_Checkout_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa a compra da túa tarxeta agasallo Zarpar para alugueiros e experiencias náuticas.`)
};

const en_gift_checkout_meta_description = /** @type {(inputs: Gift_Checkout_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete your Zarpar gift card purchase for boat rentals and nautical experiences.`)
};

/**
* | output |
* | --- |
* | "Complete your Zarpar gift card purchase for boat rentals and nautical experiences." |
*
* @param {Gift_Checkout_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_checkout_meta_description = /** @type {((inputs?: Gift_Checkout_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Checkout_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_checkout_meta_description(inputs)
	if (locale === "en") return en_gift_checkout_meta_description(inputs)
	return es_gift_checkout_meta_description(inputs)
});